import { render, staticRenderFns } from "./ApeMenu.vue?vue&type=template&id=6da285b2&scoped=true"
import script from "./ApeMenu.vue?vue&type=script&lang=js"
export * from "./ApeMenu.vue?vue&type=script&lang=js"
import style0 from "./ApeMenu.vue?vue&type=style&index=0&id=6da285b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da285b2",
  null
  
)

export default component.exports